import { ThemeWrapper } from "@verity/components";
import { CorePaper } from "@verity/components/core";
import MobileSetupInstructions from "../../../setup/components/MobileSetupInstructions";
import styles from "./index.module.css";
import VisualizerBanner from "../visualizer-banner";

export default function MobileSetupPage() {
	return (
		<ThemeWrapper scopedCssBaselineProps={{ className: styles.page }}>
			<div className={styles.visualizerBanner}>
				<VisualizerBanner />
			</div>
			<CorePaper shadowStyle="wide" className={styles.contentWrapper}>
				<MobileSetupInstructions />
			</CorePaper>
		</ThemeWrapper>
	);
}
